import { getEnv } from './env.gen';
export default getEnv(window.navigator.userAgent);
